/* eslint-disable */
export const getSanitizedState = state => (
  {
    userData: state.userData,
    tiles: state.tilesData,
    demo: state.demoData,
    activeStatus: state.status.activeStatus,
    organization: state.organizationData,
    progressBarData: state.progressBarData,
    tilesPerRow: state.tilesPerRow,
    selectedCampaign: state.selectedCampaign
  }
);
